import React, { useCallback, useEffect, useState } from 'react';
import { TextField, Autocomplete, CircularProgress } from '@mui/material';
import { getAllAgents, searchAgents } from '../../actions/agent';
import { listItemStyle, textFieldStyle } from '../../utils/consts/styles';
import Paper from '@mui/material/Paper';

const CustomField = (props) => {
  return <Paper sx={listItemStyle} {...props} />
}

export const AgentAutocomplete = ({ onSelectAgent, isDisabled = false, initAgent = null }) => {
  const [agents, setAgents] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [selectedAgent, setSelectedAgent] = useState(initAgent);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAgent = useCallback(() => {
    setIsLoading(true)
    getAllAgents()
      .then((res) => setAgents(res))
      .catch((error) => {
        console.error('Ошибка при загрузке агентов:', error);
      })
      .finally(() => setIsLoading(false))
  }, [getAllAgents, setAgents, setIsLoading])

  useEffect(() => {
    if (inputValue.trim() === '') {
      fetchAgent();
    }
  }, [inputValue]);

  useEffect(() => {
    if (inputValue.trim() === '') {
      onSelectAgent(null)
      setIsLoading(false);
      return;
    }

    if (selectedAgent)
      return;

    let isMounted = true;

    setIsLoading(true);

    const delay = setTimeout(() => {
      searchAgents(inputValue)
        .then((res) => {
          if (isMounted) {
            setAgents(res);
          }
        })
        .catch((error) => {
          console.error('Ошибка при загрузке агентов:', error);
        })
        .finally(() => setIsLoading(false));
    }, 500);

    return () => {
      clearTimeout(delay);
      isMounted = false;
    };
  }, [inputValue, setAgents, selectedAgent, onSelectAgent]);

  const getOptionLabel = (agent) => {
    if (!agent || typeof agent !== 'object') return '';
    return agent.name || '';
  };

  const isOptionEqualToValue = (option, value) => {
    if (!value || !option) return false;
    return option.id === value.id;
  };

  const handleSelectAgent = useCallback((event, value) => {
    setSelectedAgent(value || null);
    if (value && onSelectAgent) {
      onSelectAgent(value);
    }
  }, [setSelectedAgent, onSelectAgent])

  return (
    <Autocomplete
      options={agents}
      getOptionLabel={getOptionLabel}
      value={selectedAgent}
      inputValue={inputValue || ''}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      onChange={handleSelectAgent}
      loading={isLoading}
      isOptionEqualToValue={isOptionEqualToValue}
      PaperComponent={CustomField}
      disabled={isDisabled}
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Выберите агента"
          placeholder="Введите ФИО, email, компанию или номер агента"
          variant="outlined"
          size="small"
          color="warning"
          sx={textFieldStyle.style}
          InputLabelProps={textFieldStyle}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
            ...textFieldStyle,
          }}
        />
      )}
      noOptionsText="Агенты не найдены"
    />
  );
};
